import { render } from "./ModalAdminGala.vue?vue&type=template&id=4c6dfcb2&scoped=true"
import script from "./ModalAdminGala.vue?vue&type=script&lang=js"
export * from "./ModalAdminGala.vue?vue&type=script&lang=js"

import "./ModalAdminGala.vue?vue&type=style&index=0&id=4c6dfcb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6dfcb2"]])

export default __exports__